import React from 'react'
import OperationContext from './contexts/OperationContext'
import { observer } from 'mobx-react'
import NavigationManager from './NavigationManager'
import PortManager from './PortManager'
import SettingsManager from './SettingsManager'
import { mttAjax } from '../../utils/_mtt-ajax'
import PriceManager from './PriceManager'
import Modal from 'react-modal'

export const PaymentGateways = React.createContext()

class PortConfigurationOperation extends React.Component {
  static defaultProps = { prefix: '' }
  storage = window.localStorage
  managers = new Map();

  constructor (props) {
    super(props)
    if (this.props.initialPorts && this.props.initialPorts.length) {
      this.store('ports', JSON.stringify(this.props.initialPorts))
      this.store('current_port_id', JSON.stringify(this.props.initialPorts[0].port_id))
    }
  }

  componentDidMount () {
    Modal.setAppElement('body')
  }

  store (key, value) {
    this.storage.setItem(this.props.prefix + key, value)
  }

  get (key) {
    return this.storage.getItem(this.props.prefix + key)
  }

  delete (key) {
    this.storage.removeItem(this.props.prefix + key)
  }

  clear () {
    this.storage.clear()
  }

  save (callback) {
    let that = this
    mttAjax('nassau_save', {
      action: 'nassau_port_config_save_ports',
      ports: JSON.parse(that.get('ports')),
    }, callback)
  }

  getPrice (callback) {
    let that = this
    let vat = this.getManager('PortManager')?.vat

    mttAjax('nassau_get_price', {
      action: 'nassau_port_config_get_price',
      ports: JSON.parse(that.get('ports')),
      vat: vat,
    }, callback)
  }

  registerManager(string,man){
    this.managers.set(string,man);
  }
  getManager(string){
    return this.managers.get(string)
  }
  render () {
    return (
      <PaymentGateways.Provider value={this.props.available_payment_gateways}>
        <OperationContext.Provider value={this}>
          <SettingsManager>
            <PortManager useSettings={true} operation={this} registerManager={this.registerManager.bind(this)}>
              <PriceManager operation={this}>
                <SettingsManager>
                  <NavigationManager useSettings={true} operation={this}>
                    <React.Fragment>
                      {this.props.children}
                    </React.Fragment>
                  </NavigationManager>
                </SettingsManager>
              </PriceManager>
            </PortManager>
          </SettingsManager>
        </OperationContext.Provider>
      </PaymentGateways.Provider>
    )
  }
}

export default observer(PortConfigurationOperation)